import { render, staticRenderFns } from "./ProjectIntro.vue?vue&type=template&id=fae2520e&"
import script from "./ProjectIntro.vue?vue&type=script&lang=js&"
export * from "./ProjectIntro.vue?vue&type=script&lang=js&"
import style0 from "./ProjectIntro.vue?vue&type=style&index=0&id=fae2520e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports